export const REELISLE_LOGO_CIRCLE = '/brand/juwa-us-logo.jpg';
export const REELISLE_LOGO_CIRCLE_LOADING = '/brand/juwa-us-logo.jpg';
export const REELISLE_LOGO_WIDE = '/brand/juwa-us-logo.jpg';
export const REELISLE_LOGO_WIDE_TOPBAR = '/brand/juwa-us-logo.jpg';
export const REELISLE_MAIN_BANNER = '/icons/icon-512.png';
export const REELISLE_MAIN_BANNER_MOBILE = '/icons/icon-512.png';
